import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold text-primary mb-4">
        Welcome to SoMa Childcare
      </h1>
      <p className="text-lg mb-6 max-w-xl mx-auto">
        A safe, nurturing place where your child can learn, play, and grow — just like home.
      </p>
      <img
        src="photo-1578349035260-9f3d4042f1f7.avif"
        alt="Childcare"
        className="rounded-lg shadow-lg mx-auto mb-6"
      />
      <div className="space-x-4">
        <Link
          to="/about"
          className="bg-primary text-white px-4 py-2 rounded shadow hover:bg-yellow-500"
        >
          Learn More
        </Link>
        <Link
          to="/contact"
          className="bg-secondary text-white px-4 py-2 rounded shadow hover:bg-blue-500"
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
}